import React from 'react';
import { createRoot } from 'react-dom/client';

import reportWebVitals from './reportWebVitals';

import App from './App';

import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';

import { HOTJAR, GA } from './Constants/index';
import Hotjar from '@hotjar/browser';
import ReactGA from 'react-ga4';

const root = createRoot(document.getElementById('root') as HTMLElement);
root.render(
	<React.StrictMode>
		<App />
	</React.StrictMode>
);

const hotjarSiteId = Number(HOTJAR.siteId);
const hotjarVersion = Number(HOTJAR.hotjarVersion);

if (
	Number.isFinite(hotjarSiteId) &&
	hotjarSiteId > 0 &&
	Number.isFinite(hotjarVersion) &&
	hotjarVersion > 0
) {
	Hotjar.init(hotjarSiteId, hotjarVersion);
}

const googleAnalyticsMeasurementId = GA.MEASUREMENT_ID?.trim();

if (googleAnalyticsMeasurementId) {
	ReactGA.initialize(googleAnalyticsMeasurementId);
}

reportWebVitals();
